export default {
  CATEGORY: 'Product Categories',
  ALL: 'All'
};
